<template>
  <div class="modalDuplicate">
    <div style="border-radius:10px;padding:10px;" class="card">
      <img
        @click="closeModalDuplicate()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <h2 style="font-size:14px;">
        {{
          $t("meeting.duplicate.title", {
            name:
              modalDuplicate.insight !== null &&
              modalDuplicate.insight !== undefined
                ? modalDuplicate.insight.name
                : "",
          })
        }}
      </h2>
      <hr />
      <PopupDuplicate outil="profeel" :row="modalDuplicate.insight" />
    </div>
  </div>
</template>

<script>
import PopupDuplicate from "@/components/popup/PopupDuplicate";
export default {
  name: "ModalDuplicate",
  components: {
    PopupDuplicate,
  },
  props: {
    modalDuplicate: Object,
  },
  methods: {
    closeModalDuplicate() {
      this.$store.commit("MODAL_DUPLICATE", {
        sondage: null,
        activeModalDuplicate: false,
      });
    },
  },
};
</script>
<style scoped>
.modalDuplicate {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
</style>
